export default __webpack_public_path__ + "static/media/M02.21acb7e4.gif";